import { create } from 'zustand';

export const useModalSearchStore = create<{
  show: boolean;
  onShow: (value: boolean) => void;
}>((set) => ({
  show: false,
  onShow: (value: boolean) => set(() => ({ show: value })),
}));
